import { Injectable } from "@angular/core";
import { Guid } from "guid-typescript";
import * as moment from "moment";
import { Model_LogVariableEnvironnementUser } from 'src/app/app.models';
import { LogEnvVarUserOfflineDao } from './log-envvaruser-offline.dao';
import { QueryParams_LogVariableEnvironnementUser } from 'src/app/pages/views/settings/variable-environment/variable-environment.service';

const TB_RESPONSES_NAME = "LOCAL_TB_LOG_VARIABLE_ENVIRONNEMENT_USER";

@Injectable()
export class LogEnvVarUserOfflineWebDao extends LogEnvVarUserOfflineDao {
    doDeleteSyncedLogsEnvVarUserAction(): Promise<void> {
        return new Promise(async (resolve, reject) => {
            let logs = await this.doGetLogsEnvVarUserAction();
            logs.forEach(async (log) => {
                if (log.SYNCED === true) {
                    await this.doDeleteLogsEnvVarUserAction(log.GUID_SYNCHRONISATION);
                }
            });
            resolve();
        });
    }

    doSyncLogsEnvVarUserAction(_logs: Model_LogVariableEnvironnementUser[]): Promise<void> {
        return new Promise((resolve, reject) => {
          this.doClearLogsEnvVarUserAction();
          this.doInsertLogsEnvVarUserAction(_logs).then(() => {
            resolve();
          }, err => reject(err));
        });
    }

    doDeleteLogsEnvVarUserAction(_guid: string): Promise<void> {
        return new Promise((resolve, reject) => {
            this.doGetLogsEnvVarUserAction()
            .then((_logs: Model_LogVariableEnvironnementUser[]) => {
                const logIndex = _logs.findIndex(r => r.GUID_SYNCHRONISATION == _guid);
                if (logIndex != -1) {
                    _logs.splice(logIndex, 1);
                }
                localStorage.setItem(TB_RESPONSES_NAME, JSON.stringify(_logs));
                resolve();
            }, err => reject(err));
        });
    }

    doClearLogsEnvVarUserAction() {
        return new Promise<void>((resolve, reject) => {
            localStorage.setItem(TB_RESPONSES_NAME, "[]");
            resolve();
        })
    }

    doGetLogsEnvVarUserAction(_queryParams?: QueryParams_LogVariableEnvironnementUser): Promise<Model_LogVariableEnvironnementUser[]> {
        if (_queryParams === undefined) 
            _queryParams = new QueryParams_LogVariableEnvironnementUser();

        return new Promise((resolve, reject) => {
            var datas: Model_LogVariableEnvironnementUser[] = [];
            const storageDatas = localStorage.getItem(TB_RESPONSES_NAME);
            if (!!storageDatas && storageDatas != 'undefined' && storageDatas != 'null') {
                try {
                    datas = JSON.parse(storageDatas);
                    if (datas == null) { datas = []; }
                } catch(e) { console.log(e) }
            }

            if (!!_queryParams.NOM_VARIABLE) {
                datas = datas.filter(d => d.NOM_VARIABLE.toUpperCase() == _queryParams.NOM_VARIABLE.toUpperCase());
            }
            if (!!_queryParams.AGENT_ID) {
                datas = datas.filter(d => d.USER_ID == _queryParams.AGENT_ID);
            }
            if (_queryParams.SYNCED !== undefined) {
                datas = datas.filter(d => d.SYNCED == _queryParams.SYNCED);
            }

            datas = datas.sort((a, b) => {
                let date1 = moment(a.DATE_LOG);
                date1 = date1.isValid() ? date1 : moment();
                let date2 = moment(b.DATE_LOG);
                date2 = date2.isValid() ? date2 : moment();
                return date1.isBefore(date2) ? 1 : -1;
            });

            resolve(datas);
        });
    }

    doInsertLogsEnvVarUserAction(_logs: Model_LogVariableEnvironnementUser[]): Promise<void> {
        return new Promise((resolve, reject) => {
            this.doGetLogsEnvVarUserAction().then((_datasTable: Model_LogVariableEnvironnementUser[]) => {
                var newDatas = _datasTable.concat(_logs);
                localStorage.setItem(TB_RESPONSES_NAME, JSON.stringify(newDatas));
                resolve();
            }, err => reject(err));
        });
    }

    doSaveLogEnvVarUserAction(_log: Model_LogVariableEnvironnementUser): Promise<Model_LogVariableEnvironnementUser> {
        return new Promise((resolve, reject) => {
            this.doGetLogsEnvVarUserAction().then((_datasTable: Model_LogVariableEnvironnementUser[]) => {
                let itemIndex = -1;
                var newDatas = _datasTable;
                if (_log.ID === undefined && _log.GUID_SYNCHRONISATION === undefined) {
                    _log.GUID_SYNCHRONISATION = Guid.create().toString();
                    _log.SYNCED = false;
                    newDatas.push(_log);
                    itemIndex = newDatas.length - 1;
                } else {
                    itemIndex = _datasTable.findIndex(d => d.GUID_SYNCHRONISATION == _log.GUID_SYNCHRONISATION);
                    if (itemIndex > -1) {
                        newDatas[itemIndex] = _log;
                    }
                }
                localStorage.setItem(TB_RESPONSES_NAME, JSON.stringify(newDatas));
                resolve(newDatas[itemIndex]);
            }, err => {
                reject(err);
            });
        });
    }

    doGetLogEnvVarAction(_guid: string): Promise<Model_LogVariableEnvironnementUser> {
        return new Promise((resolve, reject) => {
            this.doGetLogsEnvVarUserAction().then((_datasTable: Model_LogVariableEnvironnementUser[]) => {
                const log = _datasTable.find(w => w.GUID_SYNCHRONISATION == _guid);
                resolve(log);
            }, err => reject(err));
        });
    }

    doDeleteLogEnvVarUserAction(_guid: string): Promise<void> {
        return new Promise((resolve, reject) => {
            this.doGetLogsEnvVarUserAction().then((_datasTable: Model_LogVariableEnvironnementUser[]) => {
                const logIndex = _datasTable.findIndex(w => w.GUID_SYNCHRONISATION == _guid);
                _datasTable.splice(logIndex, 1);
                localStorage.setItem(TB_RESPONSES_NAME, JSON.stringify(_datasTable));
            }, err => reject(err));
        });
    }
}
